module.exports = __webpack_public_path__ + "3dad13ebebfd0a70f6f72d96653aac30.svg";